import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify/utils';
import { useRolle } from '../auth/useRolle';
import { GuennieIcon } from '../components/GuennieIcon';
import { SpaghettiDivider } from '../components/SpaghettiDivider';
import { sichererWeiterPfad } from '../lib/weiterleitung';

I18n.putVocabularies({
  de: {
    'Sign In': 'Anmelden',
    'Sign in': 'Anmelden',
    'Signing in': 'Anmeldung läuft',
    Email: 'E-Mail-Adresse',
    Username: 'E-Mail-Adresse',
    'Enter your username': 'E-Mail-Adresse eingeben',
    Password: 'Passwort',
    'Forgot your password?': 'Passwort vergessen?',
    'Reset Password': 'Passwort zurücksetzen',
    'Enter your email': 'E-Mail-Adresse eingeben',
    'Enter your Email': 'E-Mail-Adresse eingeben',
    'Enter your Password': 'Passwort eingeben',
    'Please confirm your Password': 'Passwort bestätigen',
    'New password': 'Neues Passwort',
    'Change Password': 'Neues Passwort vergeben',
    'Your passwords must match': 'Die Passwörter müssen übereinstimmen',
    Submit: 'Bestätigen',
    Change: 'Bestätigen',
    Code: 'Bestätigungscode',
    'Confirm TOTP Code': 'Bestätigungscode aus der App',
  },
});
I18n.setLanguage('de');

function NachLogin() {
  const { authStatus } = useAuthenticator((c) => [c.authStatus]);
  const [params] = useSearchParams();
  if (authStatus === 'authenticated') {
    const weiter = params.get('weiter');
    return <Navigate to={sichererWeiterPfad(weiter ? decodeURIComponent(weiter) : null)} replace />;
  }
  return null;
}

export function Landing() {
  const { angemeldet, laedt } = useRolle();
  const [params] = useSearchParams();
  const [zeigeLogin, setZeigeLogin] = useState(Boolean(params.get('weiter')));

  useEffect(() => {
    if (params.get('weiter')) setZeigeLogin(true);
  }, [params]);

  if (!laedt && angemeldet) {
    const weiter = params.get('weiter');
    return <Navigate to={sichererWeiterPfad(weiter ? decodeURIComponent(weiter) : null)} replace />;
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          padding: '2rem 1.5rem',
        }}
      >
        <div style={{ maxWidth: '34rem', textAlign: 'center' }}>
          <GuennieIcon gefuellt groesse={72} farbe="var(--erdbeere)" />
          <h1 style={{ marginTop: '1rem' }}>GünniEis</h1>
          <p className="label">Verkostungsführer für Spaghetti-Eis</p>
          <SpaghettiDivider />
          <p style={{ fontSize: '1.05rem' }}>
            Ein kuratierter Führer zu Spaghetti-Eis aus Eisdielen – ernsthaft verkostet,
            in Günnies bewertet, auf einer Karte versammelt.
          </p>
          <p style={{ color: 'var(--espresso-70)' }}>
            Die Inhalte sind nur für angemeldete Mitglieder sichtbar. Ein Zugang wird
            von einem Verwalter eingerichtet – eine Selbstanmeldung gibt es nicht.
          </p>

          {!zeigeLogin ? (
            <button className="btn btn-primaer" onClick={() => setZeigeLogin(true)} style={{ marginTop: '1rem' }}>
              Anmelden
            </button>
          ) : (
            <div style={{ marginTop: '1.5rem', textAlign: 'left' }}>
              <Authenticator hideSignUp>
                {() => <NachLogin />}
              </Authenticator>
            </div>
          )}
        </div>
      </div>
      <footer style={{ textAlign: 'center', padding: '1.5rem', fontSize: '0.85rem', color: 'var(--espresso-70)' }}>
        <a href="/impressum">Impressum</a> · <a href="/datenschutz">Datenschutz</a>
      </footer>
    </div>
  );
}
